import { render, staticRenderFns } from "./WeeklyHomework.vue?vue&type=template&id=5a97df3e&scoped=true&"
import script from "./WeeklyHomework.vue?vue&type=script&lang=js&"
export * from "./WeeklyHomework.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyHomework.vue?vue&type=style&index=0&id=5a97df3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a97df3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a97df3e')) {
      api.createRecord('5a97df3e', component.options)
    } else {
      api.reload('5a97df3e', component.options)
    }
    module.hot.accept("./WeeklyHomework.vue?vue&type=template&id=5a97df3e&scoped=true&", function () {
      api.rerender('5a97df3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/patient/components/Calendar/components/WeeklyHomework.vue"
export default component.exports